import Toaster from "./Toast";
const toaster = new Toaster();
export { default as Position } from "./Positions";
export default toaster;



//////////////////
// WEBPACK FOOTER
// ./node_modules/toasted-notes/lib/index.js
// module id = 445
// module chunks = 0